<ng-container *ngIf="config">
    <div class="container">
        <h5 class="roboMenu"><span class="d-none d-md-inline">{{'paginator.page' |translate}}
                <input #pag type="number" id="pagina" aria-label="Pagina" aria-describedby="basic-addon1" size="4"
                    class="round_input" min="1" max="{{config.totalPages}}" value="{{config.page}}"
                    [(ngModel)]="config.page" (keyup.enter)="onValueChange()"
                    [ngbTooltip]="getTooltip('currentPage')" />
                {{'paginator.of' |translate}} {{config.totalPages}} {{'paginator.rows' |translate}} &nbsp;|
                &nbsp;</span><span> {{config.startRow}} - {{config.endRow}} {{'paginator.of' |translate}}
                {{config.totalRows}} righe</span></h5>
        <button type="button" class="btn" [disabled]="+config.page == 1" (click)="prev.emit()"><i
                class="bi bi-caret-left-fill"></i></button>
        <button type="button" class="btn" [disabled]="+config.page == config.totalPages" (click)="next.emit()"><i
                class="bi bi-caret-right-fill"></i></button>
        <button type="button" class="btn" (click)="refresh.emit()"><i class="bi bi-arrow-clockwise"></i></button>
    </div>
</ng-container>
